import { configuredString } from '@/kiosk-core/config/kioskRuntimeConfig';
import { getKioskSlug, getRuntimeApiKey } from '@/services/urlState';

export interface EntrRequestHeaderOptions {
  apiKey?: string | null;
  apiKeyHeader?: string | null;
  envApiKey?: string | null;
  envApiKeyHeader?: string | null;
}

export function getEntrRequestHeaders(
  options: EntrRequestHeaderOptions = {}
): Record<string, string> {
  const headers: Record<string, string> = {};
  const slug = getKioskSlug();
  if (slug) headers['X-Kiosk-Slug'] = slug;

  const apiKey =
    configuredString(options.apiKey) ??
    configuredString(options.envApiKey) ??
    configuredString(import.meta.env.VITE_KIOSK_API_KEY) ??
    configuredString(getRuntimeApiKey());
  const apiKeyHeader =
    configuredString(options.apiKeyHeader) ??
    configuredString(options.envApiKeyHeader) ??
    'X-Kiosk-Api-Key';
  if (apiKey) headers[apiKeyHeader] = apiKey;

  return headers;
}
